<template>
  <naj-modal
    ref="pdfDecisionsModal"
    :width="1500"
    :footer="true"
    :close-button="true"
    :show-footer-close-button="true"
    @onClose="closePDFDecisionsModal"
  >
    <v-row>
      <v-col cols="2">
        <template v-for="(jud ,index) in decisions">
          <div
            :key="index"
            :class="['row my-5 header-text judgement-entry py-2',{'outlined':index == selectedDecisionIndex}]"
            @click="getDecisionDocument(index)"
          >
            <div class="py-1 text-c-green col-6">
              {{ local.caseFile.cards.decision.codeDisplayName }}
            </div>
            <div class="py-1 text-info-value col-6">
              {{ jud.decesionCode || jud.decisionCode }}
            </div>
            <div class="py-1 text-c-green col-6">
              {{ local.caseFile.cards.decision.dateDisplayName }}
            </div>
            <div class="py-1 text-info-value col-6">
              {{ toHijriDate( jud.decisionDate) }}
            </div>
          </div>
        </template>
      </v-col>

      <v-col cols="10">
        <pdf-document-viewer
          :document="document"
          :loading="loading"
          :has-pdf-document="!!selectedDecision.spid"
          :file-name="`decision-${selectedDecision.decesionCode}.pdf`"
        />
        <div
          v-if="!loading && !document"
          class="text-center document-text preview-holder"
        >
          {{ local.common.noData }}
        </div>
      </v-col>
    </v-row>
  </naj-modal>
</template>

<script>
import PdfDocumentViewer from '../file-viewer/pdf-document-viewer.vue';

import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapCaseActions } = createNamespacedHelpers('CasesModule');
import { toHijriDate } from '@/helpers/utils';

export default {
  name: 'PdfDecisionsModal',
  components: {
    PdfDocumentViewer,
  },
  props: {
    decisions: {
      type: Array,
      required: true,
    },
    modalVisibility: {
      type: Boolean,
      required: true,
    },
    selectedDecisionIndexProp: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      document: null,
      selectedDecisionIndex: 0,
    };
  },
  computed: {
    selectedDecision() {
      return ((this.decisions || [])[this.selectedDecisionIndex]) || {};
    },
  },
  methods: {
    ...mapCaseActions(['getTrustedSourceAttachment']),
    toHijriDate,
    closePDFDecisionsModal() {
      this.resetData();
      this.$emit('modalClose');
    },
    resetData() {
      this.document = null;
      this.loading = false;
    },
    getDecisionDocument(index) {
      this.selectedDecisionIndex = index;
      if (!this.selectedDecision.spid) {
        this.document = this.selectedDecision.decisionText;
        return;
      }
      this.loading = true;
      this.getTrustedSourceAttachment(this.selectedDecision.spid)
        .then((attachment) => {
          this.document = `data:application/pdf;base64,${attachment}`;
        })
        .finally(
          () => (this.loading = false)
        );
    },
  },
  watch: {
    modalVisibility(newValue) {
      if (newValue) {
        this.$refs.pdfDecisionsModal.show();
        this.selectedDecisionIndex = this.selectedDecisionIndexProp;
        this.getDecisionDocument(this.selectedDecisionIndexProp);
      } else {
        this.$refs.pdfDecisionsModal.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.judgements-wrapper {
  direction: rtl;
}
.document-text {
  font-size: 18px;
  line-height: 1.8;
  color: #6d6d6d;
}

.preview-holder {
  display: block !important;
  height: 600px;
  width: 100%;
}

.judgement-entry {
  border: 2px solid #a2a2a2;
  border-radius: 5px;
  cursor: pointer;
  &.outlined {
    border: 4px solid #1fb9b8;
  }

  .text-info-value {
    font-size: 14px;
    font-weight: bold;
  }
}
</style>